import { Dialog as MuiDialog, IconButton, Breakpoint } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import { ReactNode } from 'react';

interface DialogProps {
  open: boolean;
  onClose: () => void;
  title: { text: string; icon?: ReactNode };
  size?: Breakpoint;
  children: ReactNode;
}

const Dialog = ({ open, onClose, title, size, children }: DialogProps) => {
  return (
    <MuiDialog open={open} onClose={onClose} fullWidth maxWidth={size || 'sm'}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {title.icon} {title.text}
      </DialogTitle>
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>{children}</DialogContent>
    </MuiDialog>
  );
};

export default Dialog;
